/* eslint-disable */
import {lista, nao_autorizado, pegaDados, processar} from '../../services/GenericAPI'
import {Filtro} from "../../models/filtro/filtro";
import {Municipio} from '../../models/municipio'
import {BaseDescSCH, getBaseSCH} from "../../search/BaseSCH";

const url = '/municipios'

const state = {
  all: [],
  allList: [],
  municipio: new Municipio(),
  filtro: new Filtro()
}

const getters = {
  listaAllMunicipios: (state) => {
    return state.allList
  },

  listaMunicipios: (state) => {
    return state.all
  },
  pegaMunicipio: (state) => {
    return state.municipio
  },
  pegaFiltro: (state) => {
    return state.filtro
  }
}

const actions = {
  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['descr','uf'], '%' + search + '%', 'ilike')
  },
  async getItem({commit}, {municipios_id, onSucesso,onErro}) {
    try {
      var filtro = getBaseSCH('municipio_id', municipios_id, '=')
      const list = (await pegaDados(url+'/get', filtro)).data
      if (list.data[0] !== undefined) {
        commit('SET_MUNICIPIO', list.data[0])
        onSucesso()
      } else {
        onErro()
      }
    } catch (error) {
      onErro()
      console.log(error)
    }
  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', BaseDescSCH(perPage))
  },

  async setAllListMunicipios({commit},{onSucesso, onErro}) {
    try {
      const list = (await lista(url + '/all')).data
      commit('SET_ALL_LIST', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
    }
  },
  async setAllMunicipios({commit},{onSucesso, onErro}) {
    try {
      const list = (await pegaDados(url + '/get', state.filtro)).data
      commit('SET_MUNICIPIOS', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro()
      nao_autorizado(error)
    }
  },
  async processarMunicipio({commit}, {acao,onSucesso,onErro}) {
    try {
      let res = await processar(url + (acao === 'gravar' ? '/commit' : '/delete'), state.municipio, acao)

      this.dispatch('geral/setMsgSuccess', res.data.message)
      onSucesso()
    } catch (error) {
      onErro()
      console.log('error: ',error)
      this.dispatch('geral/setObjMsgError', error.response.data)
    }
  },
  setMunicipio({commit}, municipio) {
    commit('SET_MUNICIPIO', municipio)
  },
}

const mutations = {

  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_MUNICIPIOS(state, municipios) {
    state.all = municipios
  },
  SET_MUNICIPIO(state, municipio) {
    state.municipio = municipio
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
